import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import Select from "react-select";
import { alertActions } from "../../../../redux/actions/alert-actions";
// import { helperFunctions as HF } from "helper/helperFunctions";
import { orderService } from "../../../../services/order";

function OrderBulkEditForm(props) {

    const [selectedBulkOption, setBulkOption] = useState({});

    async function submitBulkUpdate(e, confirm = false) {
        e.preventDefault();
        try {
            let data = {
                orders_ids: props.orders_ids,
                ...selectedBulkOption
            }
            const res = await orderService.bulkEditOrder(data)
            props.return_submitted_data(true);
            props.successAlert(res.message);
            props.closeModal();
        } catch (e) {
            props.errorAlert(e);
            console.log('Error while duplicating', e);
        }
    }

    const handleBulkOption = (selectedOption, field) => {
        // if field is undefined then its the input field 
        let tempObj = {
            id: '',
            title: '',
            field_name: '',
            value: '',
        }
        if (!field) {
            tempObj.field_name = selectedOption.target.name;
            tempObj.value = selectedOption.target.value;
        } else {
            tempObj.field_name = field.name;
            if (selectedOption) {
                tempObj.value = selectedOption.id;
                tempObj.id = selectedOption.id;
                tempObj.title = selectedOption.title;
            }
        }
        const data = {
            ...selectedBulkOption,
            [tempObj.field_name]: tempObj
        }
        if (!tempObj.value) {
            delete data[tempObj.field_name]
        }
        console.log("🚀 ~ file: OrderBulkEditForm.jsx ~ line 55 ~ handleBulkOption ~ data", data)
        setBulkOption(data)
    }

    const renderBulkUpdateField = () => {
        // if (selectedType.value === 'status') {
        return <div style={{ marginTop: '10px' }}>
            <div>
                <label>
                    Order Status:
                </label>
                <Select
                    className="text-capitalize"
                    value={selectedBulkOption.status || ''}
                    onChange={handleBulkOption}
                    options={props.order_status.sort((a, b) => a.title.localeCompare(b.title))}
                    getOptionLabel={(option) => option.title}
                    getOptionValue={(option) => option.id}
                    isSearchable={true}
                    isClearable={true}
                    name={'status'}
                    placeholder={'Order Status'}
                />
            </div>
            <div style={{ marginTop: '15px' }}>
                <label>
                    Tracking No:
                </label>
                <input
                    type="text"
                    name="tracking_number"
                    value={selectedBulkOption.tracking_number ? selectedBulkOption.tracking_number.value : ''}
                    onChange={handleBulkOption}
                    className="customInput form-control"
                    placeholder="Tracking Number"
                />
            </div>
            <div style={{ marginTop: '15px' }}>
                <label>
                    Ship Via:
                </label>
                <input
                    type="text"
                    name="ship_via"
                    value={selectedBulkOption.ship_via ? selectedBulkOption.ship_via.value : ''}
                    onChange={handleBulkOption}
                    className="customInput form-control"
                    placeholder="Ship Via"
                />
            </div>
        </div>
    }

    const clearDuplication = (e) => {
        e.preventDefault();
        setBulkOption({});
    }

    const updateOptions = [
        {
            label: 'Order Status',
            value: 'status'
        },

        {
            label: 'Ship Via',
            value: 'ship_via'
        },
        {
            label: 'Tracking No.',
            value: 'tracking_number'
        },
    ]

    return (
        <form onSubmit={submitBulkUpdate}>
            <div className="row">
                <div className="col-md-12 mb-xlg">
                    <div className="mt-xlg">
                        {/* <div>
                            <label>
                                Update:
                            </label>
                            <Select
                                value={selectedType}
                                onChange={onTypeSelect}
                                options={updateOptions}
                                isSearchable={true}
                                isClearable={true}
                                name={'update_field'}
                                placeholder={'Bulk Update Field'}
                            />
                        </div> */}

                        {renderBulkUpdateField()}
                        <div
                            className="text-center"
                            style={{
                                marginTop: '25px',
                                marginBottom: '25px',
                            }}>
                            Updating {props.orders_ids.length} Orders!
                        </div>
                        {
                            <div style={{
                                marginTop: '25px',
                            }}
                                className="text-center"
                            >
                                <button className="customBtn"
                                    style={{
                                        maxWidth: '120px',
                                        marginTop: '10px',
                                        marginRight: '15px',
                                        backgroundColor: 'black'
                                    }}
                                    onClick={(e) => {
                                        submitBulkUpdate(e, true)
                                    }}
                                    disabled={Object.keys(selectedBulkOption).length > 0 ? false : true}
                                >
                                    Confirm
                                </button>
                                <button className="customBtn"
                                    style={{
                                        maxWidth: '120px',
                                        marginTop: '10px',
                                        marginRight: '15px',
                                        backgroundColor: 'tomato'
                                    }}
                                    type="button"
                                    onClick={clearDuplication}
                                >
                                    Clear
                                </button>
                                <button className="customBtn"
                                    style={{
                                        maxWidth: '120px',
                                        marginTop: '40px',
                                        marginRight: '15px',
                                        backgroundColor: 'black'
                                    }}
                                    type="button"
                                    onClick={() => { props.closeModal() }}
                                >
                                    Cancel
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </form>
    );
}

const mapDispatchToProps = dispatch => {
    return ({
        errorAlert: (e) => {
            dispatch(alertActions.error(e))
        },
        successAlert: (msg) => {
            dispatch(alertActions.success(msg))
        },
    });
};

function mapStateToProps(state) {
    const { shippingOptions } = state.shippingOptionReducer;
    const { order_status } = state.listReducer;
    return {
        shippingOptions,
        order_status
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(OrderBulkEditForm);



// WEBPACK FOOTER //
// ./src/components/Admin/Order/Forms/OrderBulkEditForm.jsx